import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty"; //@ts-check

import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import Input from '@material-ui/core/Input';
import Icon from '../../../../core/Icon';

var styles = function styles(theme) {
  var _inputInput;

  return createStyles({
    search: _defineProperty({
      position: 'relative',
      lineHeight: 'normal',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.1),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.2)
      },
      width: '100%',
      height: '100%'
    }, theme.breakpoints.up('sm'), {
      width: 'auto'
    }),
    inputRoot: {
      color: 'inherit'
    },
    inputInput: (_inputInput = {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(5),
      transition: theme.transitions.create('width'),
      width: '100%'
    }, _defineProperty(_inputInput, theme.breakpoints.up('md'), {
      width: 120,
      '&:focus': {
        width: 200
      }
    }), _defineProperty(_inputInput, theme.breakpoints.up('sm'), {
      width: 100,
      '&:focus': {
        width: 130
      }
    }), _defineProperty(_inputInput, theme.breakpoints.down('xs'), {
      width: 60,
      '&:focus': {
        width: 120
      }
    }), _inputInput),
    searchIcon: {
      width: theme.spacing(5),
      height: '100%',
      position: 'absolute',
      top: 0,
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.2rem'
    }
  });
};
/**
 * @extends {React.Component<import('./types').NavBarSearchProps & import('@material-ui/core').WithStyles<typeof styles>> }
 */


var NavBarSearch =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NavBarSearch, _React$Component);

  function NavBarSearch() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NavBarSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NavBarSearch)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onKeyPress = function (e) {
      if (e.key !== 'Enter' || !_this.value) return;
      if (!_this.props.onSubmit) return;
      return _this.props.onSubmit(_this.value);
    };

    _this.onChange = function (e) {
      _this.value = e.target.value;
      if (!_this.props.onChange) return;
      return _this.props.onChange(_this.value);
    };

    return _this;
  }

  _createClass(NavBarSearch, [{
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return React.createElement("div", {
        className: classes.search
      }, React.createElement(Input, {
        disableUnderline: true,
        fullWidth: true,
        classes: {
          root: classes.inputRoot,
          input: classes.inputInput
        },
        placeholder: "Search...",
        onKeyPress: this.onKeyPress,
        onChange: this.onChange
      }), React.createElement(Icon, {
        type: "search",
        className: classes.searchIcon
      }));
    }
  }]);

  return NavBarSearch;
}(React.Component);

export default withStyles(styles, {
  name: 'ECNavBarSearch'
})(NavBarSearch);